import React from 'react';
import './App.css'
import Home from './Page/Home';
import Categoriemovie from './Page/Categoriemovie';
import Moviediscription from './Page/Moviediscription';
import { Route,Routes } from 'react-router-dom';
import Loader from './Page/Loader';


function App() {

  return (
    <div className="App">
     <Routes>
      <Route  index  element={<Home/>} ></Route>
      <Route path='Allmovie/:movieid'  element={<Moviediscription/>}></Route>
      <Route path='Categoriemovie/:categoriesid' element={<Categoriemovie/>}></Route>
      <Route path='Loader' element={<Loader/>}></Route>
     </Routes>
    
    </div>
  );
}

export default App;
